import { SocketEvent } from "@onair/types";
import { io, Socket } from "socket.io-client";

const SOCKET_SERVER_URL = new URL(process.env.NEXT_PUBLIC_API_URL as string)
	.origin;

export class SocketManager {
	private static instance: SocketManager | null = null;
	private socket: Socket | null = null;
	private socketUrl: string = SOCKET_SERVER_URL;

	private constructor(socketUrl: string) {
		this.socketUrl = socketUrl;
	}

	/**
	 * Lấy instance của SocketManager (singleton pattern)
	 */
	public static getInstance(
		socketUrl: string = SOCKET_SERVER_URL,
	): SocketManager {
		if (!SocketManager.instance) {
			SocketManager.instance = new SocketManager(socketUrl);
		}
		return SocketManager.instance;
	}

	/**
	 * Kết nối socket
	 */
	public connect(): void {
		if (this.socket && this.socket.connected) {
			return;
		}

		this.socket = io(this.socketUrl, {
			transports: ["websocket"],
			withCredentials: true,
		});

		// Đăng ký khi kết nối thành công
		this.socket.on("connect", () => {
			this.socket?.emit(SocketEvent.REGISTER);
		});

		// Đăng ký khi mất kết nối
		this.socket.on("disconnect", () => {
			this.disconnect();
		});
	}

	/**
	 * Disconnect socket
	 */
	public disconnect(): void {
		if (this.socket && this.socket.connected) {
			this.socket.emit(SocketEvent.QUIT);
			this.socket.disconnect();
			this.socket = null;
		}
	}

	/**
	 * Gửi event lên server
	 */
	public emit(event: string, data: unknown): void {
		if (this.socket) {
			this.socket.emit(event, data);
		}
	}

	/**
	 * Thêm event listener
	 */
	public on<T = unknown>(event: string, handler: (data: T) => void): void {
		if (this.socket) {
			this.socket.on(event, handler);
		}
	}

	/**
	 * Xóa event listener
	 */
	public off<T = unknown>(event: string, handler?: (data: T) => void): void {
		if (this.socket) {
			this.socket.off(event, handler);
		}
	}

	/**
	 * Kiểm tra trạng thái kết nối
	 */
	public isConnected(): boolean {
		return !!this.socket?.connected;
	}

	/**
	 * Lấy instance socket gốc nếu cần
	 */
	public getSocket(): Socket | null {
		return this.socket;
	}
}
